import ComponentEmitter from 'tiny-emitter';

const Emitter = new ComponentEmitter;

export default Emitter;